import React from 'react';

import Helmet from 'react-helmet';
import { useTitle } from 'ha/helpers/hooks/useTitle';
import { Language } from '@ha/intl';
import { useIntl } from 'ha/i18n';

export const ContactUsMetaData: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const title = useTitle(T('contact_us_header'));

  return (
    <Helmet>
      <title key="title">{title}</title>

      <script type="application/ld+json">
        {`{
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "HousingAnywhere.com",
          "legalName": "Housing Anywhere B.V.",
          "url": "https://housinganywhere.com/",
          "logo": "https://housinganywhere.com/img/icon-512.png",
          "foundingDate": "2009",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Blaak 555",
            "addressLocality": "Rotterdam",
            "postalCode": "3011 GB",
            "addressCountry": "NLD"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer support",
            "telephone": "[+31 85 888 1399]",
            "email": "support@housinganywhere.com"
          },
          "sameAs": [
            "${urlResolver.getFacebookUrl()}",
            "${urlResolver.getTwitterUrl()}",
            "${urlResolver.getYoutubeUrl()}",
            "${urlResolver.getLinkedinUrl()}"
          ]
        }`}
      </script>

      <script type="application/ld+json">
        {`{
          "@context": "http://schema.org",
          "@type": "Service",
          "name": "HousingAnywhere.com",
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "5",
            "reviewCount": "93"
          }
        }`}
      </script>

      <link
        key="link canonical"
        rel="canonical"
        href={urlResolver.absolutizePath(urlResolver.getContactUrl(), {
          skipAddLanguage: true,
        })}
      />
      <link
        key="link alternate x-default"
        rel="alternate"
        hrefLang="x-default"
        href={urlResolver.absolutizePath(
          urlResolver.getContactUrl(Language.en),
          {
            skipAddLanguage: true,
          },
        )}
      />
      {Object.keys(Language).map((lang: Language) => (
        <link
          key={`link alternate ${lang}`}
          rel="alternate"
          hrefLang={lang}
          href={urlResolver.absolutizePath(urlResolver.getContactUrl(lang), {
            skipAddLanguage: true,
          })}
        />
      ))}
    </Helmet>
  );
};
